import React from 'react'

import { SylexTable } from '@leshen/ui'

// Gatsby integration of @leshen/ui/Link
import Link from './Link'

const LeshenTable = ({ ...props }) => (
  <SylexTable CustomLink={Link} {...props} />
)

export default LeshenTable
